import React from 'react';
import { IconProps } from '.';

const SvgBoxGraphDownFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#fff'
        d='m4.882 8.28 3.207 6.076a.6.6 0 0 0 .848.23l4.372-2.727 2.707 4.248-2.729-.158-.069 1.198 4.084.236a.6.6 0 0 0 .633-.552l.359-4.5-1.196-.095-.237 2.963-2.86-4.486a.6.6 0 0 0-.823-.187l-4.329 2.7L5.943 7.72l-1.06.56Z'
      />
    </svg>
  );
};

export default SvgBoxGraphDownFill;
